const Typography = () => {
  return (
    <section className="col-12">
      <h2>Typography</h2>
      <hr />
      <div className="row">
        <div className="col-12 col-lg-6">
          <label className="th">Headings</label>
          <h1 className="mb-3">h1. Typography heading</h1>
          <h2 className="mb-3">h2. Typography heading</h2>
          <h3 className="mb-3">h3. Typography heading</h3>
          <h4 className="mb-3">h4. Typography heading</h4>
          <h5 className="mb-3">h5. Typography heading</h5>
          <h6 className="mb-3">h6. Typography heading</h6>
        </div>
        <div className="col-12 col-lg-6">
          <label className="th">Paragraph</label>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
            dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex
            ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat
            nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit
            anim id est laborum.
          </p>
          <div className="row">
            <label className="th">Link</label>
          </div>
          <div className="row">
            <a href="#">Some link here</a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Typography
